import React from 'react';
import ReactDOM from 'react-dom';
import './../modal.css'; // Asegúrate de tener los estilos en este archivo

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" style={{backgroundColor: 'white'}} onClick={(e) => e.stopPropagation()}>
                <span className="close" onClick={onClose}>&times;</span>
                {children}
            </div>
        </div>,
        document.getElementById('modal-root') // Asegúrate de tener un div con este id en tu HTML
    );
};

export default Modal;